import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PremiseFlat } from "../_model/store-response/premise-flat";
import { StoreFiltersResponse } from "../_model/store-response/store-filters-response";
import { StoreProperty } from "../_model/store-response/store-property";
import { StoreResponse } from "../_model/store-response/store-response";
import { UserService } from './user.service';
import { FormGroup } from '@angular/forms';
import { FilterDto } from '../_model/filterDto';
import { MultipleFilterProperty } from '../_model/multiple-filter-property';


@Injectable({
  providedIn: 'root'
})
export class StoreService {

  baseUrl = '/premise';
  filterDto: Array<FilterDto> = [];

  constructor(private http: HttpClient, private userService: UserService) {
  }

  // getStoreConfig(property: string, value: string): Observable<StoreResponse> {
  //   return this.http.get<StoreResponse>(this.userService.getClientBaseUrl() + this.baseUrl + '/property/' + property + '/value/' + value);
  // }


  filterStoreConfig(filters: FormGroup,brand: string): Observable<StoreResponse> {
    if ((filters && (typeof filters.value.multipleFilterarray != "undefined"
      && filters.value.multipleFilterarray != null
      && filters.value.multipleFilterarray.length != null
      && filters.value.multipleFilterarray.length > 0))) {
      let url = this.userService.getBaseUrl() + '/brand/' +  brand  + '/fmSystem/' + this.userService.getFmSystemId() + '/clients/'  + this.userService.getClientId() + this.baseUrl + '/filters';
      this.createBody(filters);
      let body = {
        filterListDTO: this.filterDto
      };
      this.filterDto = [];
      return this.http.post<StoreResponse>(url, body);
    }
    else if (filters) {
      let url = this.userService.getBaseUrl() + '/brand/' +  brand + '/fmSystem/' + this.userService.getFmSystemId() + '/clients/'  + this.userService.getClientId() + this.baseUrl + '/filters';
      this.createBodyForFilter(filters);
      let body = {
        filterListDTO : this.filterDto
      };
      this.filterDto = [];
      return this.http.post<StoreResponse>(url, body);
    }
     // This handles the case where `filters` is null or undefined.
  // It returns an observable that emits an empty StoreResponse object.
    return of({ 
    data: [],
    status: '200', 
    message: 'No filters provided.',
  } as StoreResponse);
  } 

  private createBodyForFilter(filters: FormGroup) {
      let dto = new FilterDto();
        dto.property = filters.value.tableFilter.column;
        dto.value = filters.value.value;
      this.filterDto.push(dto);
  }
  


  private createBody(filters: FormGroup) {
    filters.value.multipleFilterarray.forEach((element: MultipleFilterProperty) => {
      let dto = new FilterDto();
        dto.property = element.column;
        dto.value = element.value;
      this.filterDto.push(dto);
    });
  }


  // getStoreConfigFilters(): Observable<StoreFiltersResponse> {
  //   return this.http.get<StoreFiltersResponse>(this.userService.getClientUrl() + this.baseUrl + '/filters');
  // }

  getStoreConfigFilters(brand: string): Observable<StoreFiltersResponse> {
    return this.http.get<StoreFiltersResponse>(this.userService.getBaseUrl() + '/brand/' +  brand + '/fmSystem/' + this.userService.getFmSystemId() + '/clients/'  + this.userService.getClientId() + this.baseUrl + '/filters');
  } 

  createStoreConfig(body: PremiseFlat): Observable<any> {
    return this.http.post<any>(this.userService.getClientBaseNewUrl() + this.baseUrl, body);
  }

  updateStoreConfig(body: PremiseFlat): Observable<any> {
    return this.http.put<any>(this.userService.getClientBaseNewUrl() + this.baseUrl, body);
  }

  updateClientRef(body: StoreProperty[]): Observable<any> {
    return this.http.put<any>(this.userService.getClientBaseNewUrl() + this.baseUrl + '/client-ref', {premiseDetails: body});
  }
}
